import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import vuetify from './plugins/vuetify';


import APIService from './services/APIService'
import router from '@/router'

import './filters/currency';


import FlagIcon from './custom_components/flag'
Vue.use(FlagIcon);

// VueKonva is loaded lazily in components that need it

Vue.prototype.$http = APIService;
Vue.config.productionTip = false;


// Dayjs plugin (replaces vue-moment with lighter alternative)
import dayjsPlugin from './plugins/dayjs';
Vue.use(dayjsPlugin);

import i18n from './i18n'
import VuetifyConfirm from 'vuetify-confirm'


import { createPinia, PiniaVuePlugin } from 'pinia'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()

var VueScrollTo = require('vue-scrollto');

Vue.use(VueScrollTo,{offset: -200})

import PortalVue from 'portal-vue'
Vue.use(PortalVue)


Vue.use(VuetifyConfirm, {
  vuetify,
  buttonTrueText: i18n.t('v-confirm.accept-text'),
  buttonFalseText: i18n.t('v-confirm.decline-text'),
  color: 'error',
  icon: 'mdi-warning',
  title: i18n.t('v-confirm.title-text'),
  persistent: true,
  property: '$confirm'
})

import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';

Vue.filter('numFormat', numFormat(numeral));

import VueCurrencyInput from 'vue-currency-input'

Vue.use(VueCurrencyInput, {
  precision: 4,
  locale: 'de',
  distraction_free: true

});

/* eslint-disable no-new */
new Vue({
  vuetify,
  router,
  i18n,
  pinia,
  render: h => h(App)
}).$mount('#app')
